import {z} from 'zod';

import {omneticApi as api} from '@dms/api/base';

import {
  GetOnlineOfferSettingsApiResponse,
  PutOnlineOfferSettingsApiArg,
  GetOnlineOfferSettingsResponseBodySchema,
  PutOnlineOfferSettingsRequestBodySchema,
} from './types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOnlineOfferSettings: build.query<GetOnlineOfferSettingsApiResponse, void>({
      query: () => ({
        url: `/dms/v1/settings/online-offer`,
      }),
      extraOptions: {
        requestSchema: z.void(),
        responseSchema: GetOnlineOfferSettingsResponseBodySchema,
      },
      providesTags: ['onlineOfferSettings'],
    }),
    putOnlineOfferSettings: build.mutation<void, PutOnlineOfferSettingsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/online-offer`,
        method: 'PUT',
        body: queryArg.onlineOfferSettingsRequestBody,
      }),
      extraOptions: {
        requestSchema: PutOnlineOfferSettingsRequestBodySchema,
        responseSchema: z.void(),
      },
      invalidatesTags: ['onlineOfferSettings'],
    }),
  }),
});

export const {useGetOnlineOfferSettingsQuery, usePutOnlineOfferSettingsMutation} = injectedRtkApi;
